import { type UserGroup } from '#app/__generated__/api.js';
import { type OnboardingFlowType } from '#app/components/GetStartedPage/types.js';

/**
 * Given a user's user groups and onboarding type, determines if
 * the user should be redirected to the onboarding flow.
 *
 * Returns `true` if the user should go to onboarding.
 */
export const shouldRedirectToOnboarding = (
  userGroups: readonly UserGroup[],
  onboardingFlowType?: OnboardingFlowType,
): boolean => {
  if (onboardingFlowType) {
    if (onboardingFlowType === 'client') {
      return !userGroups.includes('CLIENT_ONBOARDING_COMPLETE');
    } else if (onboardingFlowType === 'independent') {
      return !userGroups.includes('CONTRACTOR_ONBOARDING_COMPLETE');
    }
  }

  return (
    !userGroups.includes('CLIENT_ONBOARDING_COMPLETE') &&
    !userGroups.includes('CONTRACTOR_ONBOARDING_COMPLETE')
  );
};
